import { lazy, Suspense, type ReactElement } from 'react';
import { Box, Button, Dialog, DialogContent, DialogTrigger, LoadingOverlay } from '@ff-it/ui';
import { usePlanMeta } from '../state';
import { targetDialog } from 'modules/balticRadioSurvey/styles.css';

const RatingReportDialog = lazy(() => import('modules/radio/RadioRatingReport/RatingReportDialog'));

export function RatingsButton(): ReactElement | null {
  const { plan_strategy, planning, locked } = usePlanMeta();
  if (plan_strategy !== 'RADIO' || !window.__RUNTIME_CONFIG__?.BALTIC_RADIO_SURVEY_ENABLED) return null;

  return (
    <Dialog dismissProps={{ outsidePress: false }}>
      <DialogTrigger>
        <Button variant="secondary" size="sm" icon="chart-simple" title="Radio ratings" aria-label="Radio ratings" />
      </DialogTrigger>
      <DialogContent
        testId="radio-ratings"
        fullHeight={planning && !locked}
        className={planning && !locked ? targetDialog : undefined}
        p="4"
        gap="3"
      >
        <Suspense
          fallback={
            <Box position="relative" flex="auto" py="8" aria-busy="true">
              <LoadingOverlay
                visible
                role="status"
                aria-label="Loading radio ratings"
                spinnerProps={{ color: 'primary', 'aria-hidden': true }}
              />
            </Box>
          }
        >
          <RatingReportDialog />
        </Suspense>
      </DialogContent>
    </Dialog>
  );
}
